/* Polkom shop: kategori sayfası – tüm sayfaları yükle, istemci tarafı filtre, sayfa başına 48 */
(() => {
  const root = document.getElementById('pk-shop-kat'); if (!root) return;
  const grid = root.querySelector('[data-grid]'), more = root.querySelector('[data-more]'), none = root.querySelector('[data-f-none]');
  const cnt = root.querySelector('[data-f-count]'), q = root.querySelector('[data-f-q]');
  const L = JSON.parse(document.getElementById('pk-shop-l').textContent);
  const STEP = 48; let limit = STEP, cards = [];
  const boxes = [...root.querySelectorAll('input[data-f]')];
  const val = (c, f) => (c.dataset[f] || '').split(',').filter(Boolean);
  function secili() { const s = {}; boxes.forEach(b => { if (b.checked) (s[b.dataset.f] ||= []).push(b.value); }); return s; }
  function uyar(c, s, haric) {
    for (const f in s) { if (f === haric) continue; const v = val(c, f); if (!s[f].some(x => v.includes(x))) return false; }
    const t = (q.value || '').trim().toLowerCase(); if (t && !t.split(/\s+/).every(w => c.dataset.q.includes(w))) return false;
    return true;
  }
  function uygula(reset) {
    if (reset) limit = STEP;
    const s = secili(); let n = 0;
    cards.forEach(c => { const ok = uyar(c, s); c.hidden = !ok || n >= limit; if (ok) n++; });
    cnt.textContent = L.count.replace('NNN', n);
    none.hidden = n > 0; more.hidden = n <= limit;
    // seçenek sayıları (o grup hariç diğer filtrelere göre)
    boxes.forEach(b => { const k = cards.filter(c => uyar(c, s, b.dataset.f) && val(c, b.dataset.f).includes(b.value)).length;
      const i = b.parentElement.querySelector('[data-n]'); if (i) i.textContent = k; b.parentElement.classList.toggle('is-0', !k && !b.checked); });
    try { const st = { s, q: q.value }; sessionStorage.setItem('pk-shop:' + location.pathname, JSON.stringify(st)); } catch (e) {}
  }
  async function yukle() {
    // ilk sayfa (48 ürün) sunucudan gelir; kalan sayfalar arka planda 4'er paralel istekle yüklenir
    const pages = +grid.dataset.pages || 1; if (pages < 2) return;
    const al = async p => { try { const u = new URL(location.href); u.searchParams.set('page', p); u.searchParams.set('section_id', root.dataset.section);
      const d = new DOMParser().parseFromString(await (await fetch(u)).text(), 'text/html'); return [...d.querySelectorAll('[data-grid] > .pk-shop-card')]; } catch (e) { return []; } };
    const sonuc = [];
    for (let p = 2; p <= pages; p += 4) { const g = []; for (let k = p; k < p + 4 && k <= pages; k++) g.push(al(k)); sonuc.push(...await Promise.all(g)); }
    const frag = document.createDocumentFragment(); sonuc.flat().forEach(c => { c.hidden = true; frag.appendChild(c); }); grid.appendChild(frag);
    cards = [...grid.querySelectorAll('.pk-shop-card')];
    uygula();
  }
  cards = [...grid.querySelectorAll('.pk-shop-card')];
  try { const st = JSON.parse(sessionStorage.getItem('pk-shop:' + location.pathname) || 'null');
    if (st) { boxes.forEach(b => b.checked = (st.s[b.dataset.f] || []).includes(b.value)); q.value = st.q || ''; } } catch (e) {}
  uygula(true); yukle();
  const kapat = () => { if (matchMedia('(max-width:900px)').matches) { root.querySelector('#pk-shop-f').classList.remove('is-open'); grid.scrollIntoView({ behavior: 'smooth', block: 'start' }); } };
  boxes.forEach(b => b.addEventListener('change', () => { uygula(true); kapat(); }));
  let tm; q.addEventListener('input', () => { clearTimeout(tm); tm = setTimeout(() => uygula(true), 150); });
  more.addEventListener('click', () => { limit += STEP; uygula(); });
  root.querySelector('[data-f-clear]').addEventListener('click', () => { boxes.forEach(b => b.checked = false); q.value = ''; uygula(true); });
  const f = root.querySelector('#pk-shop-f');
  root.querySelector('[data-f-open]').addEventListener('click', () => f.classList.toggle('is-open'));
})();
